import React from 'react';
import PropTypes from 'prop-types';
import {Divider} from 'antd';

import styles from './NewAppList.module.less';

export default function NewAppList({title, children}) {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <Divider type={'vertical'} className={styles.divider} />
                {title}
            </div>
            <div className={styles.list}>{children}</div>
        </div>
    );
}

NewAppList.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
};
